/* ===========================================================================
   MM — PARTENAIRES / RÉSEAU — LA JAUGE
   ---------------------------------------------------------------------------
   Le filet sous la rangée de cartes est la jauge du défilement horizontal :
   le segment primary a la largeur de la part visible de la rangée, et il
   voyage d'un bord à l'autre avec le scroll. Tout est proportion mesurée,
   rien n'est en dur : plus de cartes, segment plus court.

   Pas de garde temporelle ici : on ne fait qu'écrire une largeur et un
   transform depuis des valeurs déjà connues du navigateur — pas de relevé
   de géométrie qui force un reflow en cascade.
   =========================================================================== */

(function () {
	'use strict';

	if (window.__mmPartenairesReseau) return;
	window.__mmPartenairesReseau = true;

	function init(root) {
		var sections = (root || document).querySelectorAll('[data-reseau]');
		Array.prototype.forEach.call(sections, function (section) {
			if (section.dataset.mmReseauReady === '1') return;
			section.dataset.mmReseauReady = '1';

			var rangee = section.querySelector('[data-reseau-rangee]');
			var filet = section.querySelector('[data-reseau-filet]');
			var avancee = section.querySelector('[data-reseau-avancee]');
			if (!rangee || !filet || !avancee) return;

			function update() {
				var total = rangee.scrollWidth;
				var visible = rangee.clientWidth;
				var track = filet.clientWidth;
				if (total <= visible + 1) {
					/* RIEN A FAIRE DEFILER : ON RETIRE LA JAUGE.
					   Elle etait remplie a 100 %, ce qui laissait une barre
					   sous une rangee qui ne bouge pas : elle annonce un
					   defilement qui n'existe pas, et invite a un geste sans
					   effet. C'est le cas des que les cartes tiennent toutes
					   a l'ecran — trois avis sur un grand ecran, par exemple.
					   Un style inline plutot qu'un attribut hidden : une des
					   quatre feuilles qui consomment ce script pose deja un
					   display sur son filet, et un display d'auteur bat
					   l'attribut. */
					filet.style.display = 'none';
					return;
				}
				filet.style.display = '';
				/* Largeur = part visible, bornée des deux côtés : un plancher
				   pour rester attrapable à l'œil quand la rangée s'allonge,
				   et un plafond à 35 % — la proportion de la maquette. Sans
				   lui, quatre cartes dont trois visibles donnent un segment
				   aux trois quarts de la piste, qui ne se lit plus comme une
				   jauge. La course, elle, reste exacte. */
				var largeur = Math.min(Math.max(track * (visible / total), 24), track * 0.35);
				var course = track - largeur;
				var progression = rangee.scrollLeft / (total - visible);
				avancee.style.width = Math.round(largeur) + 'px';
				avancee.style.transform = 'translateX(' + Math.round(course * progression) + 'px)';
			}

			rangee.addEventListener('scroll', update, { passive: true });
			window.addEventListener('resize', update);
			update();

			/* ---------- Saisie à la souris, élan, élastique ----------
			   Le trackpad et le doigt savent défiler en travers, une souris
			   non : on lui donne la rangée à saisir. Seul le pointeur
			   « mouse » est branché — au toucher, le défilement natif fait
			   mieux que nous. Passé quelques pixels de course, le clic qui
			   suivrait le relâchement est étouffé : lâcher un drag sur une
			   carte ne doit pas l'ouvrir.

			   Trois temps, une seule physique :
			   · pendant le geste, la rangée colle à la main (1:1) ; au-delà
			     d'un bord elle RÉSISTE — la course est démultipliée, l'effet
			     élastique dit qu'il n'y a plus rien derrière ;
			   · au relâchement, elle continue sur sa vitesse mesurée (lissée
			     sur les derniers relevés : la valeur brute du dernier
			     événement est trop nerveuse) et s'éteint au frottement ;
			   · un bord atteint en vitesse ne coupe pas net : la rangée
			     DÉBORDE en proportion de l'élan, puis revient — ressort en
			     amortissement critique, il se pose sans osciller. scrollLeft
			     ne sachant pas dépasser ses bornes, le débord vit dans un
			     translateX posé sur la rangée. */
			var origineX = 0;
			var origineScroll = 0;
			var saisie = false;
			var tire = false;
			var vitesse = 0;      /* px/ms, signée comme clientX */
			var dernierX = 0;
			var dernierT = 0;
			var elanId = null;
			var debord = 0;       /* translateX courant, px */
			var enDebord = false;
			var calme = window.matchMedia('(prefers-reduced-motion: reduce)');

			var VITESSE_MAX = 6;       /* px/ms — un vrai coup de fouet monte à
			                              6-8 : borner plus bas jetait la moitié
			                              du geste, un tir fort partait comme un
			                              tir moyen */
			var FROTTEMENT = 0.95;     /* par frame de 16.7ms — à 0.92, moitié
			                              de la vitesse perdue toutes les ~140ms,
			                              l'élan mourait en travers de rangée */
			var ARRET = 0.02;          /* en-dessous, l'élan s'éteint */
			var DEBORD_MAX = 72;       /* le débord ne raconte pas un voyage */
			var PRISE = 0.55;          /* pente de l'élastique au bord (0 px de
			                              débord) — la constante du scroll iOS */

			/* Élastique ASYMPTOTIQUE, la formule de l'overscroll iOS :
			   o(x) = (1 − 1/(x·PRISE/MAX + 1)) · MAX.
			   Pente PRISE au bord, puis chaque pixel de course rend un peu
			   moins que le précédent — tirer devient continûment plus dur — et
			   la courbe tangente DEBORD_MAX sans jamais le toucher. La version
			   d'avant était linéaire puis écrêtée : la rangée collait à la main
			   à 35 % et butait net à 72px, le mur que raconte l'écrêtage. Ici
			   la dérivée ne saute jamais, il n'y a pas de mur à sentir. */
			function elastique(x) {
				return (1 - 1 / ((x * PRISE) / DEBORD_MAX + 1)) * DEBORD_MAX;
			}
			/* Le retour est la FORME FERMÉE du ressort en amortissement
			   critique : o(τ) = (o₀ + (v₀ + ω·o₀)·τ)·e^(−ω·τ). Pas
			   d'intégration pas à pas — un Euler explicite à ω et dt réels
			   surcorrige, le signe s'inverse en grossissant et la rangée
			   oscillait entre ses buttoirs. La forme fermée est exacte à
			   n'importe quel dt, et un amortissement critique ne peut pas
			   osciller, par construction. Constaté sur banc. */
			var OMEGA = 0.008;         /* rad/ms — plancher : pic à ~125ms,
			                              posé à ~600ms sur les entrées douces */
			var debordT0 = 0;
			var debordO0 = 0;
			var debordV0 = 0;
			var debordW = OMEGA;       /* raideur de l'entrée en cours */

			function poserDebord(px) {
				debord = px;
				rangee.style.transform = px ? 'translateX(' + px.toFixed(2) + 'px)' : '';
			}

			function stopperElan() {
				if (elanId) {
					cancelAnimationFrame(elanId);
					elanId = null;
				}
			}

			function borneMax() {
				return rangee.scrollWidth - rangee.clientWidth;
			}

			function entrerDebord(o0, v0, now) {
				enDebord = true;
				debordT0 = now;
				debordO0 = o0;
				/* Un débord déjà tendu qu'on relâche revient, point : une
				   vitesse qui pousserait encore vers le dehors ferait grossir
				   la courbe vers l'écrêtage. */
				if (o0 !== 0 && v0 * o0 > 0) v0 = 0;
				debordV0 = Math.max(-VITESSE_MAX, Math.min(VITESSE_MAX, v0));
				/* Partant du bord (o0 = 0), le pic du ressort vaut v0/(ω·e).
				   Tronquer v0 pour tenir sous le plafond cassait la continuité
				   du mouvement : un tir à 6 px/ms repartait à 1,6 au taquet —
				   décélération 4× d'un coup, le « freeze » avant le retour.
				   À la place, c'est ω qui s'adapte : ω = v0/(DEBORD_MAX·e),
				   plancher OMEGA. La vitesse d'entrée est intégralement
				   conservée, le pic culmine pile sous le plafond par
				   construction, et le mur répond d'autant plus sec que le
				   coup est fort — un rebond vif, pas une pause au sommet. */
				debordW = o0 === 0
					? Math.max(OMEGA, Math.abs(debordV0) / (DEBORD_MAX * Math.E))
					: OMEGA;
			}

			function elan() {
				var derniere = performance.now();
				function pas(now) {
					/* dt plafonné : un onglet qui s'endort rendrait un pas
					   géant et le frottement sauterait. */
					var dt = Math.min(now - derniere, 50);
					derniere = now;

					if (!enDebord) {
						rangee.scrollLeft -= vitesse * dt;
						vitesse *= Math.pow(FROTTEMENT, dt / 16.7);
						var x = rangee.scrollLeft;
						var bord = (x <= 0 && vitesse > 0) || (x >= borneMax() && vitesse < 0);
						if (bord && !calme.matches && Math.abs(vitesse) > ARRET) {
							/* Le bord ne stoppe pas l'élan : il le transforme
							   en débord, le ressort prend la main. dO/dt
							   suit le mouvement visuel : scrollLeft qui
							   monte, c'est un translateX qui descend. */
							entrerDebord(0, vitesse, now);
						} else if (bord || Math.abs(vitesse) < ARRET) {
							elanId = null;
							return;
						}
					} else {
						var tau = now - debordT0;
						var o = (debordO0 + (debordV0 + debordW * debordO0) * tau) * Math.exp(-debordW * tau);
						o = Math.max(-DEBORD_MAX, Math.min(DEBORD_MAX, o));
						poserDebord(o);
						if (tau > 150 && Math.abs(o) < 0.4) {
							poserDebord(0);
							enDebord = false;
							elanId = null;
							return;
						}
					}
					elanId = requestAnimationFrame(pas);
				}
				elanId = requestAnimationFrame(pas);
			}

			rangee.addEventListener('pointerdown', function (event) {
				if (event.pointerType !== 'mouse' || event.button !== 0) return;
				/* Rattraper une rangée en plein élan, c'est la saisir. */
				stopperElan();
				enDebord = false;
				saisie = true;
				tire = false;
				origineX = event.clientX;
				origineScroll = rangee.scrollLeft;
				dernierX = event.clientX;
				dernierT = performance.now();
				vitesse = 0;
			});

			rangee.addEventListener('pointermove', function (event) {
				if (!saisie) return;
				var course = event.clientX - origineX;
				if (!tire && Math.abs(course) > 5) {
					tire = true;
					rangee.classList.add('is-grab');
					try { rangee.setPointerCapture(event.pointerId); } catch (error) { /* tant pis, le drag marche sans capture */ }
				}
				if (tire) {
					var cible = origineScroll - course;
					var max = borneMax();
					if (cible < 0 && !calme.matches) {
						rangee.scrollLeft = 0;
						poserDebord(elastique(-cible));
					} else if (cible > max && !calme.matches) {
						rangee.scrollLeft = max;
						poserDebord(-elastique(cible - max));
					} else {
						rangee.scrollLeft = cible;
						if (debord) poserDebord(0);
					}
					var now = performance.now();
					var dt = now - dernierT;
					if (dt > 0) {
						var brute = (event.clientX - dernierX) / dt;
						/* Lissage normalisé par le temps : à poids fixe par
						   événement, une souris à haute cadence diluait un
						   flick rapide dans dix relevés et l'élan partait
						   sous-évalué. */
						var k = 1 - Math.pow(0.55, dt / 16.7);
						vitesse = vitesse + (brute - vitesse) * k;
						dernierX = event.clientX;
						dernierT = now;
					}
					event.preventDefault();
				}
			});

			function relacher() {
				if (!saisie) return;
				saisie = false;
				rangee.classList.remove('is-grab');
				if (!tire) return;
				/* Un débord sous la main revient toujours au bercail. */
				if (debord) {
					entrerDebord(debord, vitesse, performance.now());
					elan();
					return;
				}
				if (calme.matches) return;
				/* Une pause avant de lâcher, c'est un dépôt : pas d'élan. */
				if (performance.now() - dernierT > 80) return;
				vitesse = Math.max(-VITESSE_MAX, Math.min(VITESSE_MAX, vitesse));
				if (Math.abs(vitesse) > ARRET) elan();
			}
			rangee.addEventListener('pointerup', relacher);
			rangee.addEventListener('pointercancel', relacher);

			/* Une molette qui reprend la main coupe l'élan — et si un débord
			   est en cours, seul le ressort continue : il ne touche qu'au
			   transform, la molette garde le scroll. */
			rangee.addEventListener('wheel', function () {
				var enCours = elanId !== null;
				stopperElan();
				if (debord && enCours) {
					entrerDebord(debord, 0, performance.now());
					elan();
				}
			}, { passive: true });

			rangee.addEventListener('click', function (event) {
				if (!tire) return;
				tire = false;
				event.preventDefault();
				event.stopPropagation();
			}, true);

			/* Les logos sont des images : sans ça, le navigateur entame leur
			   drag natif à la place du nôtre. */
			rangee.addEventListener('dragstart', function (event) {
				event.preventDefault();
			});
		});
	}

	/* L'éditeur de thème recharge des sections entières : on ré-initialise. */
	document.addEventListener('shopify:section:load', function (event) {
		init(event.target);
	});

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', function () { init(); });
	} else {
		init();
	}
})();
